import routes from './routes';
import { SetRoutes } from 'components';

const CalendarsPages = () => {
    return (
        <>
            <SetRoutes routes={routes} />
        </>
    );
};

export default CalendarsPages;
